/* eslint-disable @typescript-eslint/no-var-requires */
import setDocumentTitle from 'I18n/utils/setDocumentTitle';
import Raven from 'raven-js';
import { AppRoot, renderAppRoot } from 'quartz-core/internal/root-renderer';
import { initializeAppAuth } from '../frameworkInternal/tools/auth/app/app';
import { initializeI18n } from '../frameworkInternal/tools/i18n/i18n';
import config from './quartz-config-for-app';
import { getGates } from '../framework/auth/app';
import { gate } from 'hub-http/gates';
import { initializeHistory } from '../frameworkInternal/tools/history/history';
import { mark } from './perf';
import { derivePublicLocaleInfo } from '../frameworkInternal/tools/i18n/derivePublicLocaleInfo';
import { jsx as _jsx } from "react/jsx-runtime";
let registerFn;
if (
// @ts-expect-error $quartzConfigVal cannot narrow types
undefined === 'public') {
  registerFn = require('I18n/init/register/sync/registerAllPublicData').default;
} else {
  registerFn = require('I18n/init/register/sync/registerAllData').default;
}
const shouldUseLegacyRoot = createRootApi => {
  // If createRootApi is not provided or set to false, use legacy root
  if (!createRootApi || typeof createRootApi === 'boolean') {
    return !createRootApi;
  }

  // If createRootApi is a gate, use legacy root if the gate is not enabled
  return !getGates().has(
  // eslint-disable-next-line hubspot-dev/no-bare-gate-strings
  createRootApi.isV2Gate ? createRootApi.gate : gate(createRootApi.gate));
};
export const renderApp = async ({
  prepareApp,
  AppComponent,
  getPublicLocaleInfo
}, {
  rhumbConfig,
  lang
}) => {
  var _config$i18n;
  if (config.auth !== 'app') {
    throw new Error(`Invariant: expected auth="app"`);
  }
  const {
    copilotLayoutType = 'sidebar',
    htmlTitleLangKey,
    historyBasename,
    createRootApi,
    allowSuspended = false
  } = config;
  const {
    auth
  } = await initializeAppAuth({
    queryParams: new URLSearchParams(window.location.search),
    allowSuspended
  });
  mark('quartz.authFinished');
  const {
    user,
    portal
  } = auth;
  Raven.setUserContext({
    id: `${user.user_id}`,
    email: user.email,
    // @ts-expect-error `locale` is not standard but will work
    locale: user.locale
  });
  const history = initializeHistory(historyBasename, basename => basename.replace(/:portalId/, `${portal.portal_id}`));
  const isPublicI18n = ((_config$i18n = config.i18n) === null || _config$i18n === void 0 ? void 0 : _config$i18n.languageSupport) === 'public';
  const appAuthLocaleInfo = {
    locale: user.locale,
    langEnabled: user.lang_enabled,
    timezone: portal.timezone
  };
  const publicLocaleInfo = derivePublicLocaleInfo({
    isPublicI18n,
    getPublicLocaleInfo
  });
  const [result] = await Promise.all([prepareApp(), initializeI18n({
    lang,
    createPublicProvider: isPublicI18n,
    localeInfo: isPublicI18n ? publicLocaleInfo : appAuthLocaleInfo,
    registerFn
  })]);
  mark('quartz.prepareAppFinished');
  if (htmlTitleLangKey) {
    setDocumentTitle(htmlTitleLangKey);
  }
  if (result && 'redirect' in result) {
    window.location.href = result.redirect;
  } else {
    var _result$onAfterRender;
    await renderAppRoot( /*#__PURE__*/_jsx(AppRoot, {
      history: history,
      rhumbConfig: rhumbConfig,
      rhumbTrackVisibility: config.rhumbTrackVisibility,
      children: /*#__PURE__*/_jsx(AppComponent, Object.assign({}, result === null || result === void 0 ? void 0 : result.props))
    }), {
      legacyRoot: shouldUseLegacyRoot(createRootApi),
      strictMode: config.reactStrictMode,
      copilotLayoutType
    });
    result === null || result === void 0 || (_result$onAfterRender = result.onAfterRender) === null || _result$onAfterRender === void 0 || _result$onAfterRender.call(result);
  }
};